import { IRestaurant } from '@rbi-ctg/store';
import { useServiceModeStatus } from 'hooks/use-service-mode-status';
import { serviceModeList } from 'pages/cart/service-mode-details/service-mode-list';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

interface IDefaultServiceModeOptions {
  restaurant: IRestaurant;
}

export function useDefaultServiceMode({ restaurant }: IDefaultServiceModeOptions) {
  const defaultServiceModeInStore = useFlag(LaunchDarklyFlag.DEFAULT_SERVICE_MODE_IN_STORE);
  const { serviceModeStatus } = useServiceModeStatus(restaurant);

  // Get default service mode
  const defaultAvailableServiceMode = serviceModeList.find(key => {
    return (
      key === defaultServiceModeInStore &&
      serviceModeStatus[key].available &&
      !serviceModeStatus[key].disabled
    );
  });

  // Determine the fallback service mode
  const fallbackServiceMode =
    serviceModeList.find(
      key => serviceModeStatus[key].available && !serviceModeStatus[key].disabled
    ) || serviceModeList[0];

  // Determine the initially resolved service mode
  return defaultAvailableServiceMode || fallbackServiceMode;
}
